import { atomWithReset, useResetAtom } from "jotai/utils";
import type { tGlobalServiceEditorProps } from "../types";
export const globalServiceEditorPropsAtom = atomWithReset<
  Omit<tGlobalServiceEditorProps, "onClose">
>({
  isOpen: false,
});

export const useCloseGlobalServiceEditor = () => {
  return useResetAtom(globalServiceEditorPropsAtom);
};
